import { Chip } from '@mui/material';
import { FormikHelpers } from 'formik/dist/types';
import * as React from 'react';
import * as Yup from 'yup';
import { JFormik } from '../forms/jformik/JFormik';

type CommentProps = {
  recipients?: any;
  handleSubmit?: (
    values: any
    // formik: FormikHelpers<any>
  ) => void | Promise<any>;
  type?: string;
};

export const CommentForm = ({
  recipients,
  handleSubmit = (values: any) => {},
  type = 'item',
}: CommentProps) => {
  return (
    <JFormik
      initialValues={{
        recipients: recipients,
        comment: '',
      }}
      validationSchema={Yup.object({
        comment: Yup.string().required('Please enter a comment before posting'),
      })}
      handleSubmit={(values: any, formik: FormikHelpers<any>) => {
        handleSubmit(values);
        formik.resetForm();
      }}
      form={[
        {
          name: 'comment',
          itemType: 'textfield',
          jItemProps: { multiline: true, rows: 3, variant: 'outlined' },
          label: 'Add a comment',
          gridProps: { xs: 12 },
        },
        // {
        //   precondition: (values: any) => !values?.recipients || values?.recipients?.length === 0,
        //   name: 'recipients',
        //   label: 'No recipients will be notified',
        //   itemType: 'typography',
        //   value: "sfasf",
        //   gridProps: { xs: 10 },
        // },
        {
          // precondition: (values: any) => values?.recipients && values?.recipients?.length > 0,
          name: 'recipients',
          itemType: 'autocomplete',
          options: recipients,
          multiple: true,
          disabled: true,
          label: `Recipients (must be assigned to ${type})`,
          gridProps: { xs: 12, md: 10 },
          value: recipients,
          jItemProps: {
            popupIcon: <div />,
            disableClearable: true,
            renderTags: (value: readonly string[], getTagProps: any) => {
              return value.map((option: any, index: number) => (
                <Chip
                  variant="outlined"
                  color="secondary"
                  label={typeof option === 'string' ? option : option.name}
                  size="small"
                  {...getTagProps({ index })}
                />
              ));
            },
          },
        },
        {
          name: 'submit',
          itemType: 'button',
          jItemProps: {
            type: 'submit',
            sx: { p: '0 !important', m: 0, minHeight: { xs: 42, md: 56 } },
          },
          label: 'Post',
          gridProps: { xs: 12, md: 2 },
        },
      ]}
    />
  );
};
